import Vue from "vue";
import Vant from "vant";
import "vant/lib/index.css";
Vue.use(Vant);


// WEBPACK FOOTER //
// ./src/plugins/vant.js